import Component from 'flarum/common/Component';

export default class CustomFieldsEditor extends Component {
  oninit(vnode) {
    super.oninit(vnode);
    this.values = { ...(this.attrs.values || {}) };
  }

  view() {
    const definitions = this.attrs.definitions || [];

    return (
      <div className="CustomFields-editor">
        {definitions.map((field) => this.fieldInput(field))}
      </div>
    );
  }

  fieldInput(field) {
    const value = this.values[field.key] || '';

    if (field.type === 'textarea') {
      return (
        <div className="CustomFields-field Form-group">
          <textarea
            className="FormControl CustomFields-textarea"
            placeholder={field.label}
            rows="3"
            value={value}
            oninput={(e) => this.updateValue(field.key, e.target.value)}
          />
        </div>
      );
    }

    return (
      <div className="CustomFields-field Form-group">
        <input
          className="FormControl"
          type="text"
          placeholder={field.label}
          value={value}
          oninput={(e) => this.updateValue(field.key, e.target.value)}
        />
      </div>
    );
  }

  updateValue(key, value) {
    this.values[key] = value;
    this.attrs.onchange(this.values);
  }
}
